module.exports = __webpack_public_path__ + "bfaa8ae38f275bebeef25b2ff8a74b02.svg";